import React, { useState } from "react";
import { Flex, Box, Image } from "rebass/styled-components";
import { Link } from "../../../Button";
import { Title2 } from "../../../Text";
import styled from "styled-components";
import {
  dateFormatWithDistanceSuffix,
  formatNumber,
  getClipTitle,
} from "../../../../Utilities/Clip";
import ReactPlaceholder from "react-placeholder";
import { TextRow } from "react-placeholder/lib/placeholders";
import theme from "../../../../../theme/themeThree";
import { useTranslation } from "react-i18next";
import { VerticalDivider } from "../../../Divider";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;
const StyledLink = styled(Link)`
  text-overflow: ellipsis;
  white-space: ${(props) => {
    return props.truncate ? "nowrap" : "wrap";
  }};
  overflow: hidden;
  color: inherit;
  font-weight: 500;
  ${(props) => props.theme.text.title3};
`;

const StyledTitle = styled(Title2)`
  font-weight: 500;
  white-space: normal;
  ${(props) => (props.isRemixDisplay ? ` font-size:1vw;` : ``)};
`;

const StyledImage = styled(Image)`
  width: 125px;
`;

const Views = styled(Flex)``;

const descriptionPlaceholder = (
  <Box width="200px">
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        height: "20px",
        width: "80%",
        maxWidth: "430px",
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        marginTop: theme.space[2],
        height: "14px",
        width: "40%",
        maxWidth: "430px",
      }}
    />
    <TextRow
      color={theme.colors.chalkAlpha20}
      style={{
        marginTop: theme.space[2],
        height: "10px",
        width: "30%",
        maxWidth: "300px",
      }}
    />
  </Box>
);

const Dot = styled(Flex)``;
const DateEl = styled(Flex)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

function ClipCardDescription({
  clip,
  classification,
  truncate,
  alignment,
  mt,
  height,
  to,
  isMontage,
  displayMeta = true,
  isRemixDisplay = false,
}) {
  classification = classification ? classification : "secondary";

  const clipTitle = getClipTitle(clip);
  let formatted;
  const { t } = useTranslation(`translation`, {
    keyPrefix: "clip",
  });
  const isSquadMontage = clip?.partner?.useCase === "SH";
  const isMatchMontage = clip?.partner?.useCase === "MH";
  const isCareerMontage = isMontage;
  const Meta = () => {
    if (!displayMeta) return <></>;
    return (
      <>
        <Flex alignItems={"center"} mt={3}>
          {isSquadMontage && (
            <StyledImage
              src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/montages/SquadMontage_Horizontal@2x.webp`}
            />
          )}
          {isMatchMontage && (
            <StyledImage
              src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/montages/MatchMontage_Horizontal@2x.webp`}
            />
          )}
          {isCareerMontage && (
            <StyledImage
              src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/montages/CareerMontage_Horizontal@2x.webp`}
            />
          )}
          {(isSquadMontage || isMatchMontage || isCareerMontage) && (
            <VerticalDivider height={"23px"} width="2px" mx={2} />
          )}

          <Views variant="card.views">
            {formatNumber(clip.views ? formatNumber(clip.views) : 0)}{" "}
            {t("views")}
          </Views>

          {clip?.createdDate && (
            <>
              <Dot variant="card.views" ml={2} mr={2}>
                •
              </Dot>
              <DateEl variant="card.views">{formatted}</DateEl>
            </>
          )}
        </Flex>
      </>
    );
  };
  if (clip) {
    formatted = dateFormatWithDistanceSuffix(clip.createdDate);
  }

  return (
    <>
      <Flex
        mt={mt ? mt : 1}
        alignContent={alignment ? [alignment] : "flex-start"}
        // width={width ? width : "90%"}
        justifyContent={alignment ? alignment : "flex-start"}
      >
        <ReactPlaceholder
          customPlaceholder={descriptionPlaceholder}
          ready={true}
        >
          <Flex justifyContent="space-between">
            <Flex
              flexDirection="column"
              alignItems={alignment ? [alignment] : "flex-start"}
            >
              <Flex
                flexDirection={[
                  "column-reverse",
                  "column-reverse",
                  "column-reverse",
                  "row",
                ]}
                alignItems={[
                  "flex-start",
                  "flex-start",
                  "flex-start",
                  "center",
                ]}
                mb={[1]}
                height={height ? height : null}
              >
                <Flex alignItems="center">
                  {to ? (
                    <StyledLink
                      to={to}
                      truncate={truncate}
                      variant="link.clipTitle"
                    >
                      {clipTitle}
                    </StyledLink>
                  ) : (
                    <StyledTitle isRemixDisplay={isRemixDisplay}>
                      {clipTitle}
                    </StyledTitle>
                  )}
                </Flex>
                {/* <Flex ml={[0, 0, 0, 2]} mb={[1, 1, 1, 0]}>
                  {showStudioBadge && (
                    <Flex alignItems="center">
                      <StudioBadge style={{ height: "22px", width: "22px" }} />
                    </Flex>
                  )}
                </Flex> */}
              </Flex>
              <Meta />
            </Flex>
          </Flex>
        </ReactPlaceholder>
      </Flex>
    </>
  );
}

ClipCardDescription.defaultProps = {
  height: "2em",
  mt: null,
  loading: false,
  views: 0,
  onClick: () => true,
};

export { ClipCardDescription };
